<template>
  <transition name="fade-slide">
    <div v-if="visible" class="tip-overlay" @click.self="closeComicTip">
      <div class="tip-popup" role="dialog" aria-labelledby="tip-dialog-title">
        <button
          type="button"
          class="tip-close-button"
          aria-label="关闭"
          @click="closeComicTip"
        >
          <AppIcon name="close" size="sm" aria-label="" />
        </button>

        <template v-if="step === 'select'">
          <h2 id="tip-dialog-title" class="tip-title">打赏支持</h2>
          <div class="tip-thanks-visual" aria-hidden="true">
            <img
              :src="BRAND_ASSETS.tipThanks"
              alt=""
              class="tip-thanks-icon"
            />
          </div>

          <div v-if="tipAmountLoading" class="tip-amount-loading">加载打赏档位...</div>
          <div v-else class="tip-amount-grid">
            <button
              v-for="opt in tipAmountOptions"
              :key="opt.code"
              type="button"
              class="tip-amount-btn"
              :class="{ 'is-selected': selectedTipCode === opt.code }"
              @click="selectTipCode(opt.code)"
            >
              {{ formatTipAmountLabel(opt) }}
            </button>
          </div>

          <p v-if="errorMessage" class="tip-error">{{ errorMessage }}</p>
          <p v-if="guideMessage" class="tip-guide">{{ guideMessage }}</p>
          <p v-if="guideShareUrl" class="tip-guide-url">
            <AppIcon name="share" size="xs" class="tip-guide-url__icon" aria-label="" />
            {{ guideShareUrl }}
          </p>

          <button
            type="button"
            class="tip-submit-btn"
            :disabled="loading || !canSubmitTip"
            @click="submitTip"
          >
            {{ loading ? '处理中...' : `打赏 ${selectedAmountLabel}` }}
          </button>
        </template>

        <template v-else-if="step === 'qrcode'">
          <h2 id="tip-dialog-title" class="tip-title">微信扫码支付</h2>
          <p class="tip-pay-amount">支付金额：{{ selectedAmountLabel }}</p>

          <div class="tip-qr-wrap">
            <img
              v-if="qrDataUrl"
              :src="qrDataUrl"
              alt="微信打赏支付二维码"
              class="tip-qr-image"
              :class="{ 'tip-qr-image--dimmed': isConfirmingPayment }"
            />
          </div>

          <p v-if="isConfirmingPayment" class="tip-qr-hint tip-qr-hint--confirming">
            正在确认支付结果...
          </p>
          <p v-else class="tip-qr-hint">请使用微信扫一扫完成支付</p>

          <p v-if="errorMessage" class="tip-error">{{ errorMessage }}</p>

          <button
            type="button"
            class="tip-submit-btn tip-submit-btn--secondary"
            :disabled="isConfirmingPayment"
            @click="confirmPaymentManually"
          >
            {{ isConfirmingPayment ? '确认中...' : '我已完成支付' }}
          </button>
          <button type="button" class="tip-back-btn" @click="backToSelect">
            重新选择金额
          </button>
        </template>

        <template v-else-if="step === 'success'">
          <div class="tip-thanks-visual" aria-hidden="true">
            <img
              :src="BRAND_ASSETS.tipThanks"
              alt=""
              class="tip-thanks-icon tip-thanks-icon--success"
            />
          </div>
          <div class="tip-success-icon" aria-hidden="true"></div>
          <div class="tip-success-copy">
            <h2 class="tip-title">打赏成功</h2>
            <p class="tip-success-text">感谢您的支持！</p>
          </div>
          <button type="button" class="tip-submit-btn" @click="closeComicTip">
            完成
          </button>
        </template>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { onBeforeUnmount } from 'vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import { BRAND_ASSETS } from '@/shared/assets/manifest'
import { useComicTip } from '@/features/comic/composables/useComicTip'
import { formatTipAmountLabel } from '@/features/comic/utils/tipAmountFormat'

const {
  visible,
  step,
  tipAmountOptions,
  tipAmountLoading,
  selectedTipCode,
  loading,
  errorMessage,
  guideMessage,
  guideShareUrl,
  qrDataUrl,
  isConfirmingPayment,
  selectedAmountLabel,
  canSubmitTip,
  closeComicTip,
  selectTipCode,
  submitTip,
  backToSelect,
  confirmPaymentManually,
} = useComicTip()

onBeforeUnmount(() => {
  closeComicTip()
})
</script>

<style scoped src="@/features/comic/styles/ComicTipDialog.css"></style>
